import React, { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import { Modal, Button } from "react-bootstrap";

export default function QrCodeModal({ value, onClose, show }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (value) {
      const urlData = `${window.location.origin}/product-details/${value}`;
      setUrl(urlData);
    }
  }, [value]);

  const qrRef = useRef(null);

  const downloadQrCode = () => {
    const svg = qrRef.current.querySelector("svg");
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      // Create a link and trigger download
      const pngUrl = canvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "qrcode.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    };

    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  return (
    <div>
      <Modal show={show} onHide={onClose}>
        <Modal.Header>
          <Modal.Title>QR Code</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={qrRef}>{url && <QRCode value={url} />}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="success" onClick={downloadQrCode}>
            Download QR Code
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
